export interface TenderSchemeRouteLike {
  tenderScheme?: string | null
  routeCode?: string | null
}

/**
 * 优先返回库内已落库的招标方案文案；历史数据无值时再走组装兜底。
 *
 * @param route 含 tenderScheme / routeCode 的航线对象
 * @param assembleFallback 历史数据兜底组装函数
 * @param emptyLabel 全部为空时的占位符
 * @returns 招标方案展示文案
 */
export function resolveTenderSchemeLabel(
  route?: TenderSchemeRouteLike | null,
  assembleFallback?: () => string,
  emptyLabel = '-'
): string {
  const stored = String(route?.tenderScheme || '').trim()
  if (stored) return stored
  const assembled = assembleFallback?.().trim()
  if (assembled) return assembled
  return String(route?.routeCode || '').trim() || emptyLabel
}
